import { ChangeDetectorRef, OnDestroy, Pipe, PipeTransform, inject } from '@angular/core';

@Pipe({
    name: 'delayDisplay',
    pure: false
})
/**
 * Delays rendering of the provided value by the given timeout.
 *
 * Recommended usage: components with ChangeDetectionStrategy.OnPush,
 * because this is an impure pipe and transform is invoked on each
 * change detection cycle.
 */
export class DelayDisplayImpurePipe implements PipeTransform, OnDestroy {
    private readonly cdr = inject(ChangeDetectorRef);
    private timer?: ReturnType<typeof setTimeout>;
    private displayedValue = '';
    private initialized = false;

    transform(valueToDisplay: string, delay = 500): string {
        // Initialize only once, then short-circuit on subsequent calls.
        if (this.initialized) {
            return this.displayedValue;
        }

        this.initialized = true;
        this.displayedValue = '';
        this.clearTimer();
        const nextValue = valueToDisplay ?? '';

        this.timer = setTimeout(() => {
            this.displayedValue = nextValue;
            this.cdr.markForCheck();
        }, delay);

        return this.displayedValue;
    }

    ngOnDestroy(): void {
        this.clearTimer();
    }

    private clearTimer(): void {
        if (!this.timer) {
            return;
        }

        clearTimeout(this.timer);
        this.timer = undefined;
    }
}
